import React from 'react';

import classNames from 'classnames';

export default function CentralAssumptionsTableRow({ assumption, showSourceColumn }) {
    return (
        <div className="tw-flex tw-py-2">
            <div className="tw-basis-3/12 tw-px-2 tw-space-x-2">
                <div className="tw-basis-4"></div>
                <p className="tw-text-sm tw-pl-3">{assumption.description}</p>
            </div>
            {showSourceColumn && <div className="tw-basis-3/12 tw-px-2"></div>}
            <div className={classNames('tw-px-2', { 'tw-basis-4/12': showSourceColumn, 'tw-basis-7/12': !showSourceColumn })}>
                <p className="tw-text-sm">{assumption.detailed_description}</p>
            </div>
            <div className="tw-basis-1/12 tw-px-2">
                <p className="tw-text-sm">{assumption.verified ? $t('Yes') : $t('No')}</p>
            </div>
            <div className="tw-basis-1/12 tw-px-2"></div>
        </div>
    );
}
